import React from 'react'

import { useQueryClient } from 'react-query'
import { WrappedFieldProps } from 'redux-form'

import ListBox from '~/components/shared/ListBox/ListBox'
import ListBoxItem from '~/components/shared/ListBox/ListBoxItem'

import Deserializer from '~/services/Deserializer'
import EmpriseGroup from '~/services/EmpriseGroup'

import { getListItemTextPrimary } from './categoryFilter.helpers'

interface Props {
  values: any
}

const SubcategoryMobileFilterField = ({
  values,
  input
}: Props & WrappedFieldProps) => {
  const queryClient = useQueryClient()

  const { onBlur, ...otherInputProps } = input

  return (
    <ListBox
      {...otherInputProps}
      virtualized={false}
      multiple
      optionSettings={{
        key: ['product_subcategories', values.by_type],
        loadOptions: () =>
          EmpriseGroup.getCategories({ type_name: values.by_type }).then(
            async (result) => {
              const categories = await Deserializer.deserialize(result)

              const types = queryClient.getQueryData<any[]>(
                'product_categories'
              )

              const typeId = types?.find((t) => values.by_type === t.name).id

              const filteredCategories = categories?.filter((category) =>
                category.type_ids.includes(+typeId)
              )

              return filteredCategories
            }
          ),
        optionValue: 'name',
        optionLabel: 'name'
      }}
      renderOption={({ option, selected, value, onChange }) => {
        const primary = getListItemTextPrimary(option)

        return (
          <ListBoxItem
            selected={selected}
            option={option}
            onChange={onChange}
            value={value}
            primary={primary}
          />
        )
      }}
    />
  )
}

export default SubcategoryMobileFilterField
